export const generateTransferNumber = () => {
  const timePart = Date.now() % 1_000_000;
  const randomPart = Math.floor(Math.random() * 900) + 100;
  const num = Number(
    `${timePart.toString().padStart(6, '0')}${randomPart}`
  );
  return num < 100000000 ? num + 100000000 : num;
};

export const colorsArray = [
  "#73C7C7",
  "#FF92A5",
  "#FFD86E",
  "#A084E8",
  "#9BE8D8",
  "#FFB26B",
  "#00B894",
  "#FD79A8",
  "#E17055",
  "#00CEC9",
  "#D63031",
  "#0984E3",
  "#FDCB6E",
  "#B2BEC3",
  "#81ECEC",
  "#4B70F5",
  "#FF6C22",
  "#6C5CE7",
]

export const gstStateCodes:any = {
  "jammu and kashmir": "01",
  "himachal pradesh": "02",
  "punjab": "03",
  "chandigarh": "04",
  "uttarakhand": "05",
  "haryana": "06",
  "delhi": "07",
  "rajasthan": "08",
  "uttar pradesh": "09",
  "bihar": "10",
  "sikkim": "11",
  "arunachal pradesh": "12",
  "nagaland": "13",
  "manipur": "14",
  "mizoram": "15",
  "tripura": "16",
  "meghalaya": "17",
  "assam": "18",
  "west bengal": "19",
  "jharkhand": "20",
  "odisha": "21",
  "chhattisgarh": "22",
  "madhya pradesh": "23",
  "gujarat": "24",
  "dadra & nagar haveli and daman & diu": "26",
  "maharashtra": "27",
  "karnataka": "29",
  "goa": "30",
  "lakshadweep": "31",
  "kerala": "32",
  "tamil nadu": "33",
  "puducherry": "34",
  "andaman & nicobar islands": "35",
  "telangana": "36",
  "andhra pradesh": "37",
  "ladakh": "38",
};